/* Results carousel: arrow scrolling + ADD TO BAG through fetch (sbc-cart.js opens the drawer). */
if (!customElements.get('results-carousel')) {
  customElements.define('results-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rsc-track]');
      this.prev = this.querySelector('[data-rsc-prev]');
      this.next = this.querySelector('[data-rsc-next]');
      const step = dir => {
        const slide = this.track.querySelector('.rsc__slide');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: dir * (slide ? slide.offsetWidth + gap : this.track.clientWidth), behavior: 'smooth' });
      };
      this.prev && this.prev.addEventListener('click', () => step(-1));
      this.next && this.next.addEventListener('click', () => step(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.update();

      this.querySelectorAll('[data-rsc-form]').forEach(form => {
        form.addEventListener('submit', e => {
          e.preventDefault();
          const btn = form.querySelector('button');
          btn.disabled = true;
          fetch(form.action + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
            .then(r => { if (!r.ok) throw r; })
            .catch(() => form.submit())
            .finally(() => { btn.disabled = false; });
        });
      });
    }

    update() {
      const t = this.track;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
      if (this.next) this.next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
    }
  });
}
